import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import { getEasternGreeting, formatEasternDateOnly } from '../../../utils/timezone';

const WelcomeHeader = () => {
  const { userProfile, user } = useAuth();

  const currentDate = formatEasternDateOnly(new Date(), {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const getGreeting = () => {
    return getEasternGreeting();
  };

  // Mock leave balance data - in real app, this would come from API
  const leaveBalance = {
    annual: 18,
    sick: 12,
    personal: 5
  };

  return (
    <div className="bg-card rounded-lg border border-border card-shadow p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
        {/* Employee Info Section */}
        <div className="flex items-center space-x-4 mb-4 lg:mb-0">
          <div className="relative">
            <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-primary/20">
              {userProfile?.avatar_url ? (
                <Image
                  src={userProfile?.avatar_url}
                  alt={`${userProfile?.full_name || 'Employee'} profile picture`}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-primary/10">
                  <Icon name="User" size={24} color="var(--color-primary)" />
                </div>
              )}
            </div>
            <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-success rounded-full border-2 border-card flex items-center justify-center">
              <div className="w-2 h-2 bg-white rounded-full"></div>
            </div>
          </div>
          
          <div className="flex-1">
            <div className="flex items-center space-x-2 mb-1">
              <h1 className="text-2xl font-semibold text-foreground">
                {getGreeting()}, {userProfile?.full_name || user?.email || 'Employee'}!
              </h1>
              <Icon name="Hand" size={20} color="var(--color-warning)" />
            </div>
            <p className="text-muted-foreground text-sm mb-1">
              {userProfile?.role === 'employee' ? 'Team Member' : userProfile?.role?.replace('_', ' ')?.toUpperCase() || 'Employee'}
            </p>
            <p className="text-xs text-muted-foreground">
              {currentDate}
            </p>
          </div>
        </div>

        {/* Leave Balance Cards */}
        <div className="grid grid-cols-3 gap-3 lg:gap-4">
          <div className="bg-primary/5 rounded-lg p-3 text-center border border-primary/10">
            <div className="flex items-center justify-center mb-1">
              <Icon name="Calendar" size={16} color="var(--color-primary)" />
            </div>
            <p className="text-lg font-semibold text-primary">{leaveBalance?.annual}</p>
            <p className="text-xs text-muted-foreground">Annual</p>
          </div>
          
          <div className="bg-success/5 rounded-lg p-3 text-center border border-success/10">
            <div className="flex items-center justify-center mb-1">
              <Icon name="Heart" size={16} color="var(--color-success)" />
            </div>
            <p className="text-lg font-semibold text-success">{leaveBalance?.sick}</p>
            <p className="text-xs text-muted-foreground">Sick</p>
          </div>
          
          <div className="bg-accent/5 rounded-lg p-3 text-center border border-accent/10">
            <div className="flex items-center justify-center mb-1">
              <Icon name="User" size={16} color="var(--color-accent)" />
            </div>
            <p className="text-lg font-semibold text-accent">{leaveBalance?.personal}</p>
            <p className="text-xs text-muted-foreground">Personal</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;